import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { Text, CopyButton, Box, Flex, Link } from '@sequencehq/core-components'
import {
  GreyGrey20,
  GreyGrey90,
  Primary13Regular,
  Primary13SemiBold,
  GreyGrey60
} from '@sequencehq/core-components'
import { ConfigurationManagementProps } from 'Integrations/domain'
import invariant from 'tiny-invariant'
import { AttioIntegrationPreviewCard } from './AttioIntegrationPreviewCard'

export const AttioIntegrationManagement = ({
  integration
}: ConfigurationManagementProps) => {
  invariant(integration.id === 'Attio', 'Integration is not Attio')

  const user = useQuery(dashboardv99990101Client.getSelf)
  const sequenceUserId = user.data?.sequenceUser.id
  const sequenceUserEmail = user.data?.sequenceUser.email

  return (
    <Flex flexDirection="column" gap="20px" width="100%">
      <Box
        width="100%"
        p={4}
        bgColor={GreyGrey20}
        as={Flex}
        gap={2}
        borderRadius="8px"
      >
        <Flex flexDirection="column" gap={4} width="100%">
          <Flex flexDirection="column" gap={1}>
            <Text {...Primary13SemiBold}>Configure the Attio app</Text>
            <Flex {...Primary13Regular} color={GreyGrey90} gap={1}>
              Paste your user ID into the
              <p style={{ fontWeight: 'bold' }}>Member connection</p> section of
              the Attio app,
              <Link
                textDecoration="underline"
                to="https://docs.sequencehq.com/connectors/attio"
                target="_blank"
              >
                <Text>learn more.</Text>
              </Link>
            </Flex>
          </Flex>

          <Flex {...Primary13Regular} color={GreyGrey90} flexDirection="column">
            <Flex gap={1}>
              {sequenceUserId ? (
                <>
                  <Text {...Primary13SemiBold}>User ID</Text>{' '}
                  <Text color={GreyGrey60}>({sequenceUserEmail})</Text>
                </>
              ) : (
                'Loading...'
              )}
            </Flex>

            {sequenceUserId ? (
              <Flex alignItems="center" gap={1}>
                <Text {...Primary13Regular}>{sequenceUserId}</Text>
                <CopyButton value={sequenceUserId} enableGroupHover={false} />
              </Flex>
            ) : null}
          </Flex>
        </Flex>
      </Box>

      <AttioIntegrationPreviewCard />
    </Flex>
  )
}
